
import { defineComponent } from "vue";
import LandingView from "@/views/LandingView/LandingView.vue";
import KeycloakService from "@/services/keycloak/keycloakService";
import router from "@/router";

export default defineComponent({
  name: "Home",
  data() {
    return {
      userInfo: {} as any,
    };
  },
  components: {
    LandingView,
  },

  methods: {
    login() {
      return KeycloakService.CallLogin("/redirect");
    },

    redirect() {
      const role = this.userInfo.roles[0];

      if (role == "ADMIN_IOSI") {
        router.push({ name: "Organizations" });
      } else if (role == "ADMIN") {
        router.push({ name: "Users" });
      } else {
        router.push({ name: "ScheduleClient" });
      }
    },
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") as string);
  },
});
